import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { ContentContainer, SectionSubtext, CtaWrapper } from '../../styles';
import { CTAButton as BaseCTAButton } from '../../../../../components/Header/styles';

export const FeaturesContentContainer = styled(ContentContainer)(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const FeaturesSubtext = styled(SectionSubtext)(({ theme }) => ({
  marginTop: '14px',
  [theme.breakpoints.down('md')]: {
    marginTop: '12px',
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '10px',
    fontSize: '16px',
  },
}));

export const FeaturesGridWrapper = styled(Box)(({ theme }) => ({
  marginTop: '77px',
  [theme.breakpoints.down('md')]: {
    marginTop: '50px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '36px',
  },
}));

export const FeatureCardSubtext = styled(SectionSubtext)(({ theme }) => ({
  marginTop: '30px',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    marginTop: '24px',
    fontSize: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '20px',
    fontSize: '14px',
  },
}));

export const FeaturesCtaWrapper = styled(CtaWrapper)(({ theme }) => ({
  marginTop: '77px',
  [theme.breakpoints.down('md')]: {
    marginTop: '50px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '36px',
  },
}));

export const FeaturesCTAButton = styled(BaseCTAButton)(({ theme }) => ({
  padding: '20px 50px',
  margin: 0,
  minWidth: '297px',
  [theme.breakpoints.down('md')]: {
    padding: '16px 40px',
    minWidth: '260px',
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '14px 30px',
    minWidth: '220px',
    fontSize: '16px',
    width: '100%',
    maxWidth: '297px',
  },
}));
